<!--
Important:
This Component is used only for the Vue3 application
Any modifications made should be done for Vue2 component also
Vue2File: wwwroot\js\WebsitePrimary\components\VehicleCount\FrameVehicleCount.vue
Dont forget to make the changes in both the files
Any clarifications contact Laxman
-->
<template>
  <div
    class="container vehicle-inventory-slick-section g-page-section"
    v-if="inventoryVehicledetails"
  >
    <div class="text-center my-4 vehicle-title-wrapper">
      <h3 class="vehicle-count-title">
        {{ heading ? heading : "Today's Vehicle Inventory:" }}
        <!-- {{ inventoryVehicledetails.totalVehicleCount }} -->
      </h3>
      <a
        href="/inventory"
        @click="onCommonLinkLogs(subHeading, '/inventory')"
        class="ft-12 color-black mr-3 rotational-coupon-service-link cust-link btn-websites button-link text-center text-capitalize d-block text-underline"
      >
        {{ subHeading ? subHeading : " " }}
      </a>
      <div>
        <a
          v-if="enableCountOnPrimaryControl"
          class="no-hover color-black hover-color _theme_font_bold"
          :href="`/inventory/${
            inventoryVehicledetails.newModels[0].vehicles.certified
              ? 'cpo'
              : inventoryVehicledetails.newModels[0].vehicles.type.toLowerCase()
          }`"
          @click="onCommonLinkLogs(inventoryVehicledetails.totalVehicleCount, `/inventory/${
            inventoryVehicledetails.newModels[0].vehicles.certified
              ? 'cpo'
              : inventoryVehicledetails.newModels[0].vehicles.type.toLowerCase()
          }`)"
        >
          <span class="vehicle-total-count">{{ inventoryVehicledetails.totalVehicleCount }}</span>
        </a>
      </div>

      <!--primary template-->
    </div>
    <VSlickCarousel ref="slick" v-bind="slickOptions" @beforeChange="handleBeforeChange">
      <template #prevArrow="arrowSlotProps">
        <div
          @click="
            slickDirection = 'previous';
            arrowSlotProps.onClick();
          "
          :disabled="arrowSlotProps.disabled"
        >
          <em class="primaryicon-left-arrow slick-arrow" style="cursor: pointer; z-index: 1"></em>
        </div>
      </template>
      <template #nextArrow="arrowSlotProps">
        <div
          @click="
            slickDirection = 'next';
            arrowSlotProps.onClick();
          "
          :disabled="arrowSlotProps.disabled"
        >
          <em
            class="primaryicon-right-arrow bgcolor-primary _msbi_background_color slick-arrow"
            style="color: #cccccc; cursor: pointer; z-index: 1"
          ></em>
        </div>
      </template>
      <a
        v-for="(vehicle, index) in inventoryVehicledetails.newModels"
        :key="index"
        class="cursor-pointer inventory-vehicle-block no-hover color-primary theme-text-color"
        @click.prevent="vechilesVDP(vehicle)"
      >
        <div class="d-flex justify-content-center">
          <div class="text-center py-3 coupon-fixed-btn count-img-box">
            <div class="ft-16 text-dark vehicle-model-name">
              <strong
                >{{ vehicle.vehicles.year }} {{ vehicle.vehicles.make }}
                {{ vehicle.vehicles.model }}</strong
              >
            </div>
            <div
              class="color-black ft-12"
              v-if="useSellingPriceOnInventoryControl && vehicle.vehicles.yourPrice && !hidePricing"
            >
              Starting at ${{ getThousandSeperator(vehicle.vehicles.yourPrice) }}
            </div>
            <div class="color-black ft-12" v-else-if="vehicle.vehicles.msrp && !hidePricing">
              Starting at ${{ getThousandSeperator(vehicle.vehicles.msrp) }}
            </div>
          </div>
        </div>

        <div class="w-75 mx-auto">
          <img
            v-if="useoverrides"
            :src="`${vehicle.vehicles.photoURLs}&angle=01&width=350&colorcode=${vehicle.vehicles.extColorCode}&quality=85&useoverrides=${useoverrides}&type=jpeg`"
            class="img-fluid"
            :width="imageWidth"
            :height="imageHeight"
            :alt="`${vehicle.vehicles.year} ${vehicle.vehicles.make} ${vehicle.vehicles.model}`"
          />
          <img
            v-else
            :src="`${vehicle.vehicles.photoURLs}&angle=01&width=350&colorcode=${vehicle.vehicles.extColorCode}&quality=85&type=jpeg`"
            class="img-fluid"
            :width="imageWidth"
            :height="imageHeight"
            :alt="`${vehicle.vehicles.year} ${vehicle.vehicles.make} ${vehicle.vehicles.model}`"
          />
        </div>

        <div v-if="enableCountOnPrimaryControl" class="text-center inventory-count">
          <div
            class="text-center"
            :class="inventoryCountLabel ? 'ft-20' : 'inventory-vehicle-count'"
          >
            <span>{{ vehicle.count }}</span>
            <span v-if="inventoryCountLabel" class="ft-20">
              {{ inventoryCountLabel }}
            </span>
          </div>
        </div>
      </a>
    </VSlickCarousel>
  </div>
</template>
<script type="text/javascript">
import VehicleCount from "./VehicleCount";
export default {
  mixins: [VehicleCount],
};
</script>
<style scoped>
.inventory-vehicle-count {
  font-size: 4rem;
}

.inventory-count {
  color: #ddd;
}

.inventory-vehicle-block:hover {
  padding-bottom: 10px;
  border-bottom: 3px solid;
}

.inventory-vehicle-block:hover .inventory-count {
  color: #000;
}
.img-ht {
  max-height: 70px;
  margin: 0 auto;
}
.vehicle-total-count {
  font-size: 30px;
}
</style>
